module.exports = __webpack_public_path__ + "static/tartaglia-button-c8a59c6bfe8b4f240e7912e3c3f6ccb8.png";